<ng-template
  let-extraClass="extraClass"
  #topNav>
  <tidy-top-nav
    [class]="extraClass"
    [canGoBack]="true"
    [title]="'Background Check'">
  </tidy-top-nav>
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }"></ng-container>

<ng-template #content>
  <tidy-wrapper>
    <ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'desktop' }"></ng-container>

    <ng-container *ngIf="loaded">

      <ng-container *ngIf="!backgroundCheckPending">
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'In order to get job requests from those who require a background check you\'ll need to complete a background check.
            TIDY uses a third party called TURN for background checks, the email will come from a @turning.io email.'">
          </tidy-text>
        </tidy-row>

        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'Please confirm detail about you before initiating a background check:'">
          </tidy-text>
        </tidy-row>

        <tidy-card>
          <form [formGroup]="form" novalidate action="#">
            <tidy-row>
              <tidy-radio-button
                [label]="'Do you have a felony or misdemeanor related to theft or violence?'"
                [linkText]="'Learn More'"
                (linkAction)="learnMoreFelony()"
                formControlName="felony"
                [form]="form.controls.felony"
                [items]="[{viewValue: 'Yes', value: 'yes'},{viewValue: 'No', value: 'no'}]"
                [selectError]="form.value.felony === 'yes'"
                [selectMessage]="'You are not eligible for a background check but clients without this setting can still request you.'"
                [submitted]="submitted"
                [errorMessage]="'Please select an answer.'">
              </tidy-radio-button>
            </tidy-row>
          </form>
        </tidy-card>

        <tidy-error-message
          [text]="errorMessage">
        </tidy-error-message>

        <tidy-button
          [text]="'Start Background Check'"
          [action]="startBackgroundCheck.bind(this)"
          class="primary">
        </tidy-button>
      </ng-container>

      <ng-container *ngIf="backgroundCheckPending">
        <tidy-row [align]="'center'">
          <tidy-text
            [body]="'We sent an email to '">
          </tidy-text>
          <tidy-text
            [body]="email">
          </tidy-text>
          <tidy-text
            [body]="' from our background check provider TURN (from a @turning.io email). Check your email and complete the check to proceed. Please allow 24 hours for the email to arrive.'">
          </tidy-text>
        </tidy-row>

        <tidy-error-message
          [text]="errorMessage">
        </tidy-error-message>

        <tidy-button
          [text]="'Resend Email'"
          [action]="resendBackgroundCheckEmail.bind(this)"
          class="primary">
        </tidy-button>
      </ng-container>

    </ng-container>
  </tidy-wrapper>
</ng-template>

<app-scroll-wrapper [templateContent]="content"></app-scroll-wrapper>
